
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.6.0
 * Query Engine version: f676762280b54cd07c770017ed3711ddde35f37a
 */
Prisma.prismaVersion = {
  client: "6.6.0",
  engine: "f676762280b54cd07c770017ed3711ddde35f37a"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  impersonate: 'impersonate',
  permissions: 'permissions',
  ghostMemberId: 'ghostMemberId',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  version: 'version',
  showExperimentalModels: 'showExperimentalModels',
  enableAnalytics: 'enableAnalytics',
  enableRequestLogging: 'enableRequestLogging',
  stripeId: 'stripeId',
  annotationUsage: 'annotationUsage',
  stripeSubscriptionId: 'stripeSubscriptionId',
  stripeUsageSubscriptionItemId: 'stripeUsageSubscriptionItemId',
  paymentWarning: 'paymentWarning',
  enabled: 'enabled'
};

exports.Prisma.OrganizationMemberScalarFieldEnum = {
  id: 'id',
  organizationId: 'organizationId',
  userId: 'userId',
  role: 'role',
  queueViewIds: 'queueViewIds',
  projectIds: 'projectIds',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  onboardingStep: 'onboardingStep',
  showExperimentalModels: 'showExperimentalModels',
  enableAnalytics: 'enableAnalytics',
  enableReviewQueue: 'enableReviewQueue',
  enableRequestLogging: 'enableRequestLogging',
  enableVideoModeration: 'enableVideoModeration',
  stripeId: 'stripeId',
  trialEndsAt: 'trialEndsAt',
  annotationUsage: 'annotationUsage',
  exampleFittingUsage: 'exampleFittingUsage',
  stripeSubscriptionId: 'stripeSubscriptionId',
  stripeUsageSubscriptionId: 'stripeUsageSubscriptionId',
  stripeUsageSubscriptionItemId: 'stripeUsageSubscriptionItemId',
  paymentWarning: 'paymentWarning',
  enabled: 'enabled',
  surveyAnswerDate: 'surveyAnswerDate',
  priceVersion: 'priceVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  currentUsagePeriodId: 'currentUsagePeriodId'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  apiKey: 'apiKey',
  filter: 'filter',
  name: 'name',
  description: 'description',
  userId: 'userId',
  queueViewIDs: 'queueViewIDs',
  region: 'region',
  concatPreviousMessages: 'concatPreviousMessages',
  dryRunEnabled: 'dryRunEnabled',
  unicodeSpoofDetectionDisabled: 'unicodeSpoofDetectionDisabled',
  createdAt: 'createdAt',
  organizationId: 'organizationId'
};

exports.Prisma.ReportingScalarFieldEnum = {
  id: 'id',
  reason: 'reason',
  userId: 'userId',
  value: 'value'
};

exports.Prisma.WordlistScalarFieldEnum = {
  id: 'id',
  name: 'name',
  strict: 'strict',
  userId: 'userId',
  words: 'words',
  createdAt: 'createdAt',
  organizationId: 'organizationId'
};

exports.Prisma.QuotaUsageScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  usage: 'usage',
  month: 'month',
  year: 'year',
  organizationId: 'organizationId'
};

exports.Prisma.QuotaUsagePeriodScalarFieldEnum = {
  id: 'id',
  usage: 'usage',
  organizationId: 'organizationId',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  reported: 'reported',
  createdAt: 'createdAt'
};

exports.Prisma.ApiRequestScalarFieldEnum = {
  id: 'id',
  contentId: 'contentId',
  projectId: 'projectId',
  userId: 'userId',
  flagged: 'flagged',
  timestamp: 'timestamp',
  content: 'content',
  content_context: 'content_context',
  language: 'language',
  contextId: 'contextId',
  authorId: 'authorId',
  usage: 'usage',
  objectType: 'objectType',
  flaggedFields: 'flaggedFields',
  metadata: 'metadata',
  createdAt: 'createdAt',
  organizationId: 'organizationId'
};

exports.Prisma.CustomModelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  baseModel: 'baseModel',
  migratedFrom: 'migratedFrom',
  migratedTo: 'migratedTo',
  name: 'name',
  type: 'type',
  data: 'data',
  maxChars: 'maxChars',
  status: 'status',
  autoAnnotating: 'autoAnnotating',
  externalId: 'externalId',
  tempExternalId: 'tempExternalId',
  trainingTimeLeft: 'trainingTimeLeft',
  f1Score: 'f1Score',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.TrainingExampleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  text: 'text',
  labelIdx: 'labelIdx',
  embedding: 'embedding',
  tokensCount: 'tokensCount',
  modelId: 'modelId'
};

exports.Prisma.FileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  type: 'type',
  url: 'url',
  data: 'data',
  userId: 'userId'
};

exports.Prisma.AiAgentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  description: 'description',
  model: 'model',
  rules: 'rules',
  ruleLabels: 'ruleLabels',
  context: 'context',
  strictnessLevel: 'strictnessLevel',
  maxChars: 'maxChars',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.QueueViewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  isDefault: 'isDefault',
  name: 'name',
  description: 'description',
  sort: 'sort',
  beforeDate: 'beforeDate',
  afterDate: 'afterDate',
  within: 'within',
  withinUnit: 'withinUnit',
  isFlagged: 'isFlagged',
  languages: 'languages',
  projectIDs: 'projectIDs',
  minScoreThreshold: 'minScoreThreshold',
  maxScoreThreshold: 'maxScoreThreshold',
  labels: 'labels',
  filteredActionIDs: 'filteredActionIDs',
  organizationId: 'organizationId'
};

exports.Prisma.RequestCheckedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  requestId: 'requestId',
  queueViewId: 'queueViewId',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.ModerationActionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  key: 'key',
  description: 'description',
  removesFromQueue: 'removesFromQueue',
  possibleValues: 'possibleValues',
  valueRequired: 'valueRequired',
  freeText: 'freeText',
  queueBehaviour: 'queueBehaviour',
  userId: 'userId',
  position: 'position',
  filterInQueueIds: 'filterInQueueIds',
  organizationId: 'organizationId'
};

exports.Prisma.ActionPerformedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  requestId: 'requestId',
  actionId: 'actionId',
  value: 'value',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.WebhookScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  lastUsed: 'lastUsed',
  name: 'name',
  description: 'description',
  type: 'type',
  url: 'url',
  moderationActionId: 'moderationActionId',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.WebhookSecretScalarFieldEnum = {
  id: 'id',
  value: 'value',
  expires: 'expires',
  createdAt: 'createdAt',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.DiscordGuildSettingsScalarFieldEnum = {
  id: 'id',
  guild_id: 'guild_id',
  api_key: 'api_key',
  warning_message: 'warning_message',
  log_channel_id: 'log_channel_id',
  flag_behaviour: 'flag_behaviour',
  name: 'name',
  log_bot_actions: 'log_bot_actions',
  organizationId: 'organizationId',
  projectId: 'projectId'
};

exports.Prisma.VideoModelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  description: 'description',
  frameCaptureInterval: 'frameCaptureInterval',
  maxFramesPerVideo: 'maxFramesPerVideo',
  spreadFrames: 'spreadFrames',
  imageModelIds: 'imageModelIds',
  userId: 'userId',
  organizationId: 'organizationId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};
exports.Permission = exports.$Enums.Permission = {
  IMPERSONATE: 'IMPERSONATE'
};

exports.OrganizationRole = exports.$Enums.OrganizationRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  DEVELOPER: 'DEVELOPER',
  MODERATOR: 'MODERATOR'
};

exports.ModerateObjectType = exports.$Enums.ModerateObjectType = {
  text: 'text',
  image: 'image',
  video: 'video',
  profile: 'profile',
  event: 'event',
  product: 'product',
  object: 'object'
};

exports.ModelType = exports.$Enums.ModelType = {
  CLASSIFIER: 'CLASSIFIER',
  ENTITY_EXTRACTOR: 'ENTITY_EXTRACTOR',
  TRANSFORMER: 'TRANSFORMER',
  IMAGE_CLASSIFIER: 'IMAGE_CLASSIFIER',
  VIDEO_CLASSIFIER: 'VIDEO_CLASSIFIER'
};

exports.ModelStatus = exports.$Enums.ModelStatus = {
  DRAFT: 'DRAFT',
  NOT_TRAINED: 'NOT_TRAINED',
  TRAINING: 'TRAINING',
  TRAINED: 'TRAINED',
  ERROR: 'ERROR'
};

exports.AgentModel = exports.$Enums.AgentModel = {
  GPT35: 'GPT35',
  GPT4TURBO: 'GPT4TURBO',
  GPT4OMINI: 'GPT4OMINI',
  LLAMA_GUARD_3: 'LLAMA_GUARD_3'
};

exports.StrictnessLevel = exports.$Enums.StrictnessLevel = {
  EASYGOING: 'EASYGOING',
  BALANCED: 'BALANCED',
  NORMAL: 'NORMAL',
  MODERATE: 'MODERATE',
  STRICT: 'STRICT'
};

exports.QueueSort = exports.$Enums.QueueSort = {
  FIFO: 'FIFO',
  LIFO: 'LIFO',
  RANDOM: 'RANDOM'
};

exports.WithinUnit = exports.$Enums.WithinUnit = {
  MINUTES: 'MINUTES',
  HOURS: 'HOURS',
  DAYS: 'DAYS',
  WEEKS: 'WEEKS',
  MONTHS: 'MONTHS',
  YEARS: 'YEARS'
};

exports.FlaggedFilter = exports.$Enums.FlaggedFilter = {
  ALL: 'ALL',
  FLAGGED: 'FLAGGED',
  NOT_FLAGGED: 'NOT_FLAGGED'
};

exports.ActionQueueBehaviour = exports.$Enums.ActionQueueBehaviour = {
  REMOVE: 'REMOVE',
  ADD: 'ADD',
  NO_CHANGE: 'NO_CHANGE'
};

exports.ActionPosition = exports.$Enums.ActionPosition = {
  ALL_QUEUES: 'ALL_QUEUES',
  SOME_QUEUES: 'SOME_QUEUES',
  HIDDEN: 'HIDDEN'
};

exports.WebhookType = exports.$Enums.WebhookType = {
  QUEUE_ITEM_NEW: 'QUEUE_ITEM_NEW',
  QUEUE_ITEM_COMPLETED: 'QUEUE_ITEM_COMPLETED',
  QUEUE_ITEM_ACTION: 'QUEUE_ITEM_ACTION'
};

exports.DiscordFlagBehaviour = exports.$Enums.DiscordFlagBehaviour = {
  FLAG: 'FLAG',
  DELETE: 'DELETE',
  NO_CHANGE: 'NO_CHANGE'
};

exports.WordlistType = exports.$Enums.WordlistType = {
  BLOCKLIST: 'BLOCKLIST',
  ALLOWLIST: 'ALLOWLIST',
  PASS: 'PASS'
};

exports.DetectionMode = exports.$Enums.DetectionMode = {
  NORMAL: 'NORMAL',
  SUSPICIOUS: 'SUSPICIOUS',
  PARANOID: 'PARANOID'
};

exports.LabelFilterType = exports.$Enums.LabelFilterType = {
  FLAGGED: 'FLAGGED',
  NOT_FLAGGED: 'NOT_FLAGGED',
  THRESHOLDS: 'THRESHOLDS'
};

exports.Prisma.ModelName = {
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  OrganizationMember: 'OrganizationMember',
  Organization: 'Organization',
  VerificationToken: 'VerificationToken',
  Project: 'Project',
  Reporting: 'Reporting',
  Wordlist: 'Wordlist',
  QuotaUsage: 'QuotaUsage',
  QuotaUsagePeriod: 'QuotaUsagePeriod',
  ApiRequest: 'ApiRequest',
  CustomModel: 'CustomModel',
  TrainingExample: 'TrainingExample',
  File: 'File',
  AiAgent: 'AiAgent',
  QueueView: 'QueueView',
  RequestChecked: 'RequestChecked',
  ModerationAction: 'ModerationAction',
  ActionPerformed: 'ActionPerformed',
  Webhook: 'Webhook',
  WebhookSecret: 'WebhookSecret',
  DiscordGuildSettings: 'DiscordGuildSettings',
  VideoModel: 'VideoModel'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
